import { render } from "./OurStory.vue?vue&type=template&id=bfe8f3ae&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=bfe8f3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe8f3ae"]])

export default __exports__